class StorageService {
	static storage: Storage = window.localStorage;

	static get: <T>(key: string) => T | null = (key: string) => {
		const data: string | null = this.storage.getItem(key);
		if (typeof data === 'string' || data === null) {
			return data;
		}
		return JSON.parse(data);
	};

	static set = (key: string, data: unknown) => {
		this.storage.setItem(key, typeof data === 'string' ? data : JSON.stringify(data));
	};

	static delete = (key: string) => {
		this.storage.removeItem(key);
	};

	static clear = () => {
		this.storage.clear();
	};
}

export { StorageService };
